import BaseController from "./base_controller";

export default class extends BaseController {
    static values = {
        url: String
    }

    async download(event) {
        event.preventDefault()

        try {
            const params = new URLSearchParams()
            params.set('format', 'xlsx') // always include this

            const { forward, to, from, commodityClass } = this.element.dataset
            if (forward) params.set('forward', forward)
            if (to) params.set('to', to)
            if (from) params.set('from', from)
            if (commodityClass) params.set('commodity_class', commodityClass)

            const response = await fetch(`${this.element.dataset.xlsxDownloadUrlValue}?${params}`, {
                headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            })

            if (!response.ok) throw new Error("Download failed")

            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement("a")
            a.href = url
            const today = new Date()
            const yyyy = today.getFullYear()
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const dd = String(today.getDate()).padStart(2, '0')
            const market = forward === 'true' ? 'fwd_market' : 'curr_market'
            a.download = `vessel_list_${market}_${yyyy}-${mm}-${dd}.xlsx`
            document.body.appendChild(a)
            a.click()
            a.remove()
        } catch (error) {
            alert("Failed to export XLSX.")
        } finally {
            this.hideLoading()
        }
    }
}
